/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CertificateInfoDto,
  TenantEmailSettingsDto,
  TenantEmailSettingsEditDto,
  TenantSecuritySettingsDto,
} from '../models/index';
import {
    CertificateInfoDtoFromJSON,
    CertificateInfoDtoToJSON,
    TenantEmailSettingsDtoFromJSON,
    TenantEmailSettingsDtoToJSON,
    TenantEmailSettingsEditDtoFromJSON,
    TenantEmailSettingsEditDtoToJSON,
    TenantSecuritySettingsDtoFromJSON,
    TenantSecuritySettingsDtoToJSON,
} from '../models/index';

export interface SetKestrelCertificateSettingsRequest {
    file?: Blob;
    password?: string;
}

export interface SetTenantEmailSettingsRequest {
    tenantEmailSettingsEditDto?: TenantEmailSettingsEditDto;
}

/**
 * 
 */
export class TenantsApi extends runtime.BaseAPI {

    /**
     */
    async getKestrelCertificateSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CertificateInfoDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/tenants/certificate-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => CertificateInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getKestrelCertificateSettings(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getKestrelCertificateSettingsRaw(initOverrides);
        return this.configuration.handleFunction<CertificateInfoDto>(response, errorHandlers);
    }

    /**
     */
    async getTenantEmailSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEmailSettingsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/tenants/email-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEmailSettingsDtoFromJSON(jsonValue));
    }

    /**
     */
    async getTenantEmailSettings(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getTenantEmailSettingsRaw(initOverrides);
        return this.configuration.handleFunction<TenantEmailSettingsDto>(response, errorHandlers);
    }

    /**
     */
    async getTenantSecuritySettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantSecuritySettingsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/tenants/security-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => TenantSecuritySettingsDtoFromJSON(jsonValue));
    }

    /**
     */
    async getTenantSecuritySettings(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getTenantSecuritySettingsRaw(initOverrides);
        return this.configuration.handleFunction<TenantSecuritySettingsDto>(response, errorHandlers);
    }

    /**
     */
    async setKestrelCertificateSettingsRaw(requestParameters: SetKestrelCertificateSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CertificateInfoDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('File', requestParameters.file as any);
        }

        if (requestParameters.password !== undefined) {
            formParams.append('Password', requestParameters.password as any);
        }

        const response = await this.request({
            path: `/api/tenants/certificate-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => CertificateInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async setKestrelCertificateSettings(requestParameters: SetKestrelCertificateSettingsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.setKestrelCertificateSettingsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<CertificateInfoDto>(response, errorHandlers);
    }

    /**
     */
    async setTenantEmailSettingsRaw(requestParameters: SetTenantEmailSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEmailSettingsEditDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/tenants/email-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TenantEmailSettingsEditDtoToJSON(requestParameters.tenantEmailSettingsEditDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEmailSettingsEditDtoFromJSON(jsonValue));
    }

    /**
     */
    async setTenantEmailSettings(requestParameters: SetTenantEmailSettingsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.setTenantEmailSettingsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<TenantEmailSettingsEditDto>(response, errorHandlers);
    }

}
